
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface ConsultationExpert {
  id: string;
  full_name: string;
  professional_title: string;
  bio: string;
  short_description: string | null;
  years_experience: number;
  specializations: string[];
  hourly_rate: number;
  rating: number | null;
  review_count: number | null;
  profile_image_url: string | null;
  linkedin_url: string | null;
  website_url: string | null;
  google_calendar_link: string | null;
  is_featured: boolean | null;
  display_order: number | null;
}

export function useConsultationExperts() {
  return useQuery({
    queryKey: ["consultation-experts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("consultation_experts")
        .select("*")
        .eq("status", "active")
        .order("display_order", { ascending: true })
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      return data as ConsultationExpert[];
    },
  });
}
